import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {Relevance, RelevanceType} from "../../interface";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'hero-relevance',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
  ],
  templateUrl: './hero-relevance.component.html',
  styleUrl: './hero-relevance.component.scss'
})
export class HeroRelevanceComponent {
  @Input() public sectionTitle: string = '';
  @Input() public topicTitle: string = '';
  @Input() public topicDescription: string = '';

  @Input({required : true}) public relevance!: Relevance | null;

  @Input() readOnly : boolean = false;

  @Output() close = new EventEmitter();
  @Output() save = new EventEmitter<Relevance | null>();

  isStrength : boolean = false;
  isDevelopment : boolean = false;
  isNotImportant : boolean = false;
  isAchieved : boolean = false;

  valueOfStrength : string = '';
  developmentGoals : string = '';

  remarksAndMilestones : string = '';

  actionPlans : {
    plan: string;
    area: string;
    from: [string, string];
    to: [string, string];
  }[] = [
    {
      plan : '',
      area : '',
      from : ['',''],
      to : ['','']
    }
  ];


  constructor(
    private cdr: ChangeDetectorRef, // For manual change detection
  ) { }


  ngAfterViewInit(): void {
    if(this.relevance){
      this.isStrength = this.relevance['type'] === RelevanceType.Strength;
      this.isDevelopment = this.relevance['type'] === RelevanceType.Development;
      this.isNotImportant = this.relevance['type'] === RelevanceType.NotImportant;
      this.isAchieved = this.relevance['type'] === RelevanceType.Achieved;
      this.valueOfStrength = this.relevance['valueOfStrength'];
      this.developmentGoals = this.relevance['developmentGoals'];
      this.remarksAndMilestones = this.relevance['remarksAndMilestones'];
      this.actionPlans = this.relevance['actionPlans'];
      this.cdr.detectChanges();
    }
  }

  onClose(){
    this.close.emit();
  }

  onSave() {

    let type : RelevanceType | null = null;

    if(this.isStrength){
      type = RelevanceType.Strength;
    }
    else if (this.isDevelopment){
      type = RelevanceType.Development;
    }
    else if (this.isNotImportant){
      type = RelevanceType.NotImportant;
    }
    else if (this.isAchieved){
      type = RelevanceType.Achieved;
    }

    if(type === undefined){
      this.save.emit(null);
    }
    else {
      this.save.emit({
        type : type as RelevanceType,
        valueOfStrength : this.valueOfStrength,
        developmentGoals : this.developmentGoals,
        remarksAndMilestones : this.remarksAndMilestones,
        actionPlans : this.actionPlans,
      });
    }

    this.onClose();
  }

  toogleStrength(){
    this.isStrength = !this.isStrength;
    if(this.isStrength){
      this.isDevelopment = false;
      this.isNotImportant = false;
      this.isAchieved = false;
    }
  }

  toogleDevelopment(){
    this.isDevelopment = !this.isDevelopment;
    if(this.isDevelopment){
      this.isStrength = false;
      this.isNotImportant = false;
      this.isAchieved = false;
    }
  }
  toogleNotImportant(){
    this.isNotImportant = !this.isNotImportant;
    if(this.isNotImportant){
      this.isStrength = false;
      this.isDevelopment = false;
      this.isAchieved = false;
    }
  }

  toogleAchieved(){
    this.isAchieved = !this.isAchieved;
    if(this.isAchieved){
      this.isStrength = false;
      this.isDevelopment = false;
      this.isNotImportant = false;
    }
  }

  addActionPlan(){
    this.actionPlans.push({
      plan : '',
      area : '',
      from : ['',''],
      to : ['','']
    });
  }
}
